import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatChipOption } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sibat-chip-base',
  template: `
    <mat-chip-option (click)="emitSelected()">
      {{ name }}
      <mat-icon (click)="emitClick(); $event.stopPropagation()">{{ icon }}</mat-icon>
    </mat-chip-option>
  `,
  styles: [
    `
      /* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version. */
      mat-chip {
        cursor: pointer;
      }

      mat-chip-option {
        padding: 7px 12px !important;
        min-height: 18px !important;
        max-height: 18px !important;

        ::ng-deep .mat-mdc-chip-action-label {
          line-height: 35px !important;
        }
      }

      mat-icon {
        margin-left: 5px;
        position: relative;
        top: 6px;
      }
    `,
  ],
  imports: [MatChipOption, MatIcon],
})
export class ChipBaseComponent {
  @Input() icon: string;
  @Input() name: string;
  @Output() selected = new EventEmitter();
  @Output() iconClicked = new EventEmitter();

  emitSelected() {
    this.selected.emit();
  }

  emitClick() {
    this.iconClicked.emit();
  }
}
